export * from './objekt-delete-request.interface';
export * from './objekt-delete-response.interface';
export * from './objekt-delete.shapes';
